import { Pipe, PipeTransform } from '@angular/core';

import { GRIDSTACK_CONSTANTS } from '@module-instance/form-builder-modal/common';
import { CipoFroalaOptions } from '@shared/components/froala/interfaces';

@Pipe({
  name: 'froalaHeight',
})
export class FroalaHeightPipe implements PipeTransform {
  transform(options: CipoFroalaOptions, rows: number): CipoFroalaOptions {
    const froalaHeight = GRIDSTACK_CONSTANTS.cellHeight * rows - 100; // 100 for froala toolbars, the left is editor height
    return {
      ...options,
      heightMin: froalaHeight - 1,
      heightMax: froalaHeight,
    };
  }
}
